import { Component  } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { DPlayerService } from 'angular-dplayer';
//import { PushNotificationsService} from 'ng-push';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent {
  title = 'airportMLFE';
  status: any = {};
  debug: string;
  faCheckCircle = faCheckCircle;

  constructor(
    db: AngularFireDatabase, 
    //private _pushNotifications: PushNotificationsService,
    private DPService: DPlayerService) {

    //this._pushNotifications.requestPermission();

    db.object('/').valueChanges().subscribe(data => {
      console.log(data);
      this.status = data;
      this.debug = JSON.stringify(data);

      let elementEstancia = document.getElementById('msg_estancia')
      let elementRepostando = document.getElementById('msg_repostando')
      let elementMaletas = document.getElementById('msg_maletas')
      let elementCompania = document.getElementById('msg_compania')
      let elementModel = document.getElementById('msg_model')

      if (data['estancia'] == true) {
        elementEstancia.className = 'highlight';
        setTimeout(() => { elementEstancia.className = 'no-highlight'; }, 1500);
      } else {
        elementEstancia.className = 'red-highlight';
        setTimeout(() => { elementEstancia.className = 'no-highlight'; }, 1500);
      }

      if (data['compania'] == "NO_COMPANY") {
        this.status.compania = "-";
        elementCompania.className = 'red-highlight';
        setTimeout(() => { elementCompania.className = 'no-highlight'; }, 1500);
      } else {
        elementCompania.className = 'highlight';
        setTimeout(() => { elementCompania.className = 'no-highlight'; }, 1500);
      }

      if (data['companiaAutoML'] == "NO_COMPANY") {
        this.status.companiaAutoML = "-";
      } 

      if (data['Repostando'] == true) {
        elementRepostando.className = 'highlight';
        setTimeout(() => { elementRepostando.className = 'no-highlight'; }, 1500);
      } else {
        elementRepostando.className = 'red-highlight';
        setTimeout(() => { elementRepostando.className = 'no-highlight'; }, 1500);
      }

      if (data['Model'] != "NO" && data['Model'] != "NO_MODEL") {
        elementModel.className = 'highlight';
        setTimeout(() => { elementModel.className = 'no-highlight'; }, 1500);
      } else {
        this.status.Model = "-"
        elementModel.className = 'red-highlight';
        setTimeout(() => { elementModel.className = 'no-highlight'; }, 1500);
      }
      
      if (data['maletas'] == true) {
        elementMaletas.className = 'highlight';
        setTimeout(() => { elementMaletas.className = 'no-highlight'; }, 1500);
      } else {
        elementMaletas.className = 'red-highlight';
        setTimeout(() => { elementMaletas.className = 'no-highlight'; }, 1500);
      }

      /*PUSH NOTIFICATION */
      /*if (data['estancia'] == true) {
        this._pushNotifications.create(
          'NEW PLANE PARKED', {
          body: this.status.companiaAutoML + " parked, Click to have a look!"
        }).subscribe(res => {
            if (res.event.type === 'click') {
                // You can do anything else here
                window.open("https://poc-ml-imagesrecognition.firebaseapp.com", "_blank");
                res.notification.close();
            }
        }
        );
      }*/
    });
  }
}
